import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.split";

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* eslint-disable react/no-unused-prop-types */


import React from 'react';
import { mergeProps } from '@arcblock/ux/lib/Util';
import PostLatest from '../post_latest';
import './style.css'; // FIXME: due to limitations of gatsby, the component is written in class

var PostTabs = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PostTabs, _React$Component);

  var _super = _createSuper(PostTabs);

  function PostTabs(props) {
    var _this;

    var newProps = mergeProps(props, PostTabs, ['limit']);
    _this = _React$Component.call(this, newProps) || this;
    var categories = (newProps.categories || '').split(',').map(function (x) {
      return x.trim();
    }).filter(Boolean);
    var titles = (newProps.titles || '').split(',').map(function (x) {
      return x.trim();
    }).filter(Boolean);

    if (!categories.length) {
      throw new Error('PostTabs component requires valid `categories` prop');
    }

    if (categories.length !== titles.length) {
      throw new Error('PostTabs component requires valid `categories` and `titles` prop');
    }

    _this.categories = categories;
    _this.titles = titles;
    _this.state = {
      selected: categories[0]
    };
    return _this;
  }

  var _proto = PostTabs.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        locale = _this$props.locale,
        limit = _this$props.limit,
        viewMore = _this$props.viewMore,
        viewAll = _this$props.viewAll;
    var selected = this.state.selected;
    return /*#__PURE__*/React.createElement("div", {
      className: "post-tabs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tab"
    }, this.categories.map(function (x) {
      return /*#__PURE__*/React.createElement("span", {
        key: x,
        className: selected === x ? 'tab-item tab-item-selected' : 'tab-item',
        onClick: function onClick() {
          return _this2.setState({
            selected: x
          });
        }
      }, _this2.titles[_this2.categories.indexOf(x)]);
    })), /*#__PURE__*/React.createElement(PostLatest, {
      locale: locale,
      limit: limit,
      category: selected,
      viewMore: viewMore,
      viewAll: viewAll
    }));
  };

  return PostTabs;
}(React.Component);

export { PostTabs as default };
PostTabs.defaultProps = {
  limit: 5,
  viewAll: '',
  viewMore: ''
};